import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionRepresentantesComponent {
  clienteId
  data
  onChange

  constructor (ClienteInformacionRepresentantes) {
    this.ClienteInformacionRepresentantes = ClienteInformacionRepresentantes
  }

  $onchanges (changes) {
    if (changes.data && !this.data) {
      this.promise = this.ClienteInformacionRepresentantes.get(this.clienteId)
        .then(({data}) => (this.data = data))
    }
  }

  agregar (item) {
    this.agregando = false

    if (item) {
      this.data = [...this.data, item]
      this.onChange({$event: {detail: this.data}})
    }
  }
}

module.component('clienteInformacionRepresentantes', {
  controller: ClienteInformacionRepresentantesComponent,
  template,
  bindings: {
    clienteId: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/representantes/component.js